import React, { useState, useEffect } from "react";
import { InfoArea } from "./styles";
import { StyledRow } from "./styles";
import { CommonBusinessType } from "components/commonBusinessType/index.js";
import RadioGroupButtonForProjectCategory from "components/radioGroupButtonForProjectCategory";
import { useSelector } from "react-redux";
import { getECQSWizardContextSelector } from "data/selectors/ecqs";

export const Step5 = ({
  setDisable,
  addData,
  setAddData,
  isMobile
}) => {
  const wizardContext = useSelector(getECQSWizardContextSelector);
  const isESub = wizardContext === "e-sub";
  const [containsUNSPC, setContainsUNSPC] = useState(false);

  const confirmRadioChange = (val) => {
    if (val === 1) {
      console.log("no unspc:", val);
      setContainsUNSPC(false);
      isESub ? setAddData("project_info.is_unspc_category_type", false) : setAddData("is_unspc_category_type", false);
    } else {
      console.log("yes unspc:", val);
      setContainsUNSPC(true);
      isESub ? setAddData("project_info.is_unspc_category_type", true) : setAddData("is_unspc_category_type", true);
    }
  };

  // Temporarily disabled to prevent interference
  // useEffect(() => {
  //   if (isESub && addData?.categories) {
  //     setAddData("project_info.categories", addData.categories);
  //   }
  // }, [isESub, setAddData]);

  // Log addData when component unmounts

  return (
    <InfoArea isMobile={isMobile} marginTop="0px" marginLeft="8px" isColumn={true} >
      <RadioGroupButtonForProjectCategory
        containsUNSPC={containsUNSPC}
        confirmRadioChange={confirmRadioChange}
      />
      <StyledRow isMobile={isMobile}>
        <CommonBusinessType
          data={addData}
          setData={setAddData}
          isMobile={isMobile}
          notPopup={true}
          containsUNSPC={containsUNSPC}
          attribute={isESub ? "project_info.categories" : "categories"}
        />
      </StyledRow>
    </InfoArea>

  )
}